// Angular
import { Injectable } from '@angular/core';

// Services
import { ApiService } from '@app/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private apiService: ApiService) {}

  public init(agentData) {
    if (!agentData) {
      return console.log('No agent data available.');
    }

    const theme = agentData.company_information.colors;

    // set css variable for each theme color
    document.documentElement.style.setProperty(`--color-primary`, theme.color1);
    document.documentElement.style.setProperty(`--color-secondary`, theme.color2);
    document.documentElement.style.setProperty(`--color-accent`, theme.color3);
  }
}
